// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/styles/client/styles.scss
// module id = 8
// module chunks = 0